import { BasicCaseProposalProps } from "../types";
import SelectionBox from "./SelectionBox";
import {
    DescriptionText,
    ProposalImage,
    StyledButton,
    StyledText,
    TextWrapper,
} from "./BasicCaseProposal.styles";

const BasicCaseProposal = ({
    boxPosition = "side",
    color,
    description,
    handleClick,
    image,
    isActive,
    isCompact = false,
    isDisabled,
    isTextAlignedStart = false,
    text,
}: BasicCaseProposalProps) => {
    const hasRichContent = Boolean(image || description);
    const isStartAligned = isTextAlignedStart || hasRichContent;

    const proposalImage = image ? (
        <ProposalImage
            src={image}
            alt=""
            $isActive={isActive}
            $isDisabled={isDisabled}
        />
    ) : null;
    const proposalDescription = description ? (
        <DescriptionText $isActive={isActive} $isDisabled={isDisabled}>
            {description}
        </DescriptionText>
    ) : null;

    return (
        <StyledButton
            disabled={isDisabled}
            onClick={handleClick}
            $boxPosition={boxPosition}
            $isActive={isActive}
            $color={color}
            $isCompact={isCompact}
            aria-pressed={isActive}
            data-option-content
            data-testactive={isActive}
        >
            <SelectionBox
                color={color}
                isActive={isActive}
                isDisabled={isDisabled}
                size={isCompact ? "medium" : "large"}
            />
            {proposalImage}
            <TextWrapper
                data-option-text
                $hasBoxOffset={!isCompact && !isStartAligned}
                $isCompact={isCompact}
                $isTextAlignedStart={isStartAligned}
            >
                <StyledText $isRich={hasRichContent} $isActive={isActive}>
                    {text}
                </StyledText>
                {proposalDescription}
            </TextWrapper>
        </StyledButton>
    );
};

export default BasicCaseProposal;
